import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage"; // これで redux store が localStorage に永続化される。
import RootReducer from "../reducers/root_reducer.ts";

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Redux Toolkit の導入前（つまり configureStore の使用前）の
      // すべての状態やアクションがシリアライズ可能な値のみを含むという確証がないため、
      // Redux Toolkit の導入時にシリアライズチェックを一括で無効にしました。
      // また、そうでなくても redux-persist が内部的にシリアライズできない値を使用することがあるようです。
      // TODO: ignoredActions を設定するなどして、チェックの無効化範囲を最小限にしてください。
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export { store, persistor };
